import { List } from 'immutable';
export const getDatasetColumnMinValue = (dataset, column) => {
  const columnMin = (dataset === null || dataset === void 0 ? void 0 : dataset.has('data')) && Math.min(...List(dataset.get('data').map(row => row.get(column)).filter(columnVal => typeof columnVal === 'number')).toJS());
  return Number.isFinite(columnMin) ? columnMin : false;
};
export const getDatasetColumnMaxValue = (dataset, column) => {
  const columnMax = (dataset === null || dataset === void 0 ? void 0 : dataset.has('data')) && Math.max(...List(dataset.get('data').map(row => row.get(column)).filter(columnVal => typeof columnVal === 'number')).toJS());
  return Number.isFinite(columnMax) ? columnMax : false;
};